import { cn } from '@lyearn/style';
import { Box } from '@lyearn/ui';
import { UseContentBookmarkParams } from '@/features/bookmark/hooks/useContentBookmark';

import { BookmarkProps } from '../types';
import { APPEARANCE_CLASSES, BOOKMARKED_CONFIG } from './utils';

const BookmarkMobile: React.FC<BookmarkProps & UseContentBookmarkParams> = (props) => {
  const { appearance = 'primary', className, classes, bookmarkId } = props;

  if (!bookmarkId) {
    return null;
  }

  const { Icon } = BOOKMARKED_CONFIG;
  const stateClassName = classes?.icon?.bookmarked;
  const iconClassName = APPEARANCE_CLASSES[appearance];

  return (
    <Box className={className}>
      <Icon className={cn('h-24 w-24', iconClassName, stateClassName, classes?.icon?.root)} />
    </Box>
  );
};

export default BookmarkMobile;
